// import React, { useState } from "react";
// import ChatBot from "react-simple-chatbot";
// import { ThemeProvider } from "styled-components";
// import { FaCommentDots } from "react-icons/fa";

// const ChatbotComponent = () => {
//   const [isChatbotOpen, setIsChatbotOpen] = useState(false); // Track if the chatbot is open

//   const toggleChatbot = () => {
//     setIsChatbotOpen(!isChatbotOpen); // Toggle chatbot open state
//   };

//   const theme = {
//     background: "#f5f8fb",
//     fontFamily: "Helvetica Neue",
//     headerBgColor: "#25D366",
//     headerFontColor: "#fff",
//     headerFontSize: "15px",
//     botBubbleColor: "#25D366",
//     botFontColor: "#fff",
//     userBubbleColor: "#fff",
//     userFontColor: "#4a4a4a",
//   };

//   const steps = [
//     {
//       id: "1",
//       message: "Hello! How can I assist you today?",
//       trigger: "user-options",
//     },
//     {
//       id: "user-options",
//       options: [
//         {
//           value: "services",
//           label: "Tell me about services",
//           trigger: "services",
//         },
//         { value: "contact", label: "How to contact you?", trigger: "contact" },
//         {
//           value: "gallery",
//           label: "Show me the gallery",
//           trigger: "gallery-options",
//         },
//       ],
//     },
//     {
//       id: "services",
//       message:
//         "Chilli Export , Chilli Import , Custom Packaging , Bulk Supply , Quality Control , Market Insights",
//       end: false,
//     },
//     {
//       id: "contact",
//       options: [
//         {
//           value: "phone",
//           label: "Phone",
//           trigger: "phone-number",
//         },
//         {
//           value: "email",
//           label: "Email",
//           trigger: "email-ids",
//         },
//       ],
//       // message:
//       //   "Phone No: 9087624545,8680907810 EmailIDs: vsrgloballink@gmail.com",
//       // end: false,
//     },
//     {
//       id: "phone-number",
//       message: "Phone No: 9087624545, 8680907810",
//       trigger: "contact",
//       // end: false,
//     },
//     {
//       id: "email-ids",
//       message: "Email IDs : vsrgloballink@gmail.com",
//       trigger: "contact",
//       //end: false,
//     },
//     {
//       id: "gallery-options",
//       message: "Here are our chilli varieties. Please select one to know more:",
//       trigger: "gallery-list",
//     },
//     {
//       id: "gallery-list",
//       options: [
//         {
//           value: "sannam",
//           label: "Dry Red Chillies - SANNAM",
//           trigger: "sannam",
//         },
//         { value: "teja", label: "Dry Red Chillies - TEJA", trigger: "teja" },
//         {
//           value: "wrinkle",
//           label: "Dry Red Chillies - 273 WRINKLE",
//           trigger: "wrinkle",
//         },
//         {
//           value: "byadgi",
//           label: "Dry Red Chillies - BYADGI",
//           trigger: "byadgi",
//         },
//       ],
//     },
//     {
//       id: "sannam",
//       message:
//         "Dry Red Chillies - SANNAM: Medium heat, vibrant color, popular in Asian cuisine.",
//       trigger: "more-gallery-options",
//     },
//     {
//       id: "teja",
//       message:
//         "Dry Red Chillies - TEJA: Known for its high heat and bright red color.",
//       trigger: "more-gallery-options",
//     },
//     {
//       id: "wrinkle",
//       message:
//         "Dry Red Chillies - 273 WRINKLE: Less spicy, suitable for milder dishes.",
//       trigger: "more-gallery-options",
//     },
//     {
//       id: "byadgi",
//       message:
//         "Dry Red Chillies - BYADGI: Rich red color, low heat, perfect for vibrant color in dishes.",
//       trigger: "more-gallery-options",
//     },
//     {
//       id: "more-gallery-options",
//       message: "Would you like to learn more about another variety?",
//       trigger: "gallery-list", // Go back to the gallery list
//     },
//   ];

//   return (
//     <div className="chatbot-container">
//       {!isChatbotOpen && (
//         <button style={{ border: "none", background:"none", borderRadius: "40%" }}>
//           <FaCommentDots
//             className="chatbot-icon"
//             onClick={toggleChatbot}
//             size={50}
//             //color="#25D366"
//             color="darkGreen"
//           />{" "}
//           {/* Message icon */}
//         </button>
//       )}
//       {isChatbotOpen && (
//         <div className="chatbot-content">
//           <button className="close-chatbot" onClick={toggleChatbot}>
//             ✖ {/* Close button */}
//           </button>
//           <ThemeProvider theme={theme}>
//             <ChatBot steps={steps} />
//           </ThemeProvider>
//         </div>
//       )}
//     </div>
//     // <div className="chatbot-container">
//     //   <ThemeProvider theme={theme}>
//     //     <ChatBot steps={steps} />
//     //   </ThemeProvider>
//     // </div>
//   );
// };

// export default ChatbotComponent;

import React, { useState } from "react";
import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import { FaCommentDots } from "react-icons/fa";
import jsonData from "../data/data.json";

// Sample data (replace this with your actual data)
const data = {
  Header: {
    title: "Madhura",
    description: "Trade Mark Of VSR Global Link Export & Import",
    paragraph:
      "Delivering the finest quality chillies from farm to market, connecting global spice trade with excellence and reliability.",
  },
  About: {
    paragraph:
      "We are passionate about bringing the bold flavors of premium chillies to the global market. With years of experience in the spice trade, we specialize in sourcing, exporting, and importing the finest quality chillies from trusted growers around the world. Our commitment to excellence ensures that every chilli we deliver meets the highest standards of freshness, taste, and sustainability.",
    Why: ["Top-Quality Chillies", "Global Reach"],
    Why2: ["Sustainable Practices", "Competitive Pricing"],
    certifications: ["33AAYFV2172L1ZI", "AAYFV2172L"],
  },
  Services: [
    {
      icon: "fa fa-ship",
      name: "Chilli Export",
      text:
        "We specialize in exporting a diverse range of high-quality chillies, ensuring that our clients receive only the best products from trusted growers worldwide.",
    },
    {
      icon: "fa fa-cart-plus",
      name: "Chilli Import",
      text:
        "Importing chillies from across the globe, we handle every aspect of the process, from sourcing to delivery. Our expertise in navigating customs and regulations ensures a smooth import experience for our clients.",
    },
    // Add other services as needed
  ],
  Contact: {
    phone: "9087624545 , 8680907810",
    email: "vsrgloballink@gmail.com",
    facebook: "fb.com",
    twitter: "twitter.com",
    youtube: "youtube.com",
  },
};

const ChatbotComponent = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false); // Track if the chatbot is open
  const [data] = useState(jsonData);

  const toggleChatbot = () => {
    setIsChatbotOpen(!isChatbotOpen); // Toggle chatbot open state
  };

  const theme = {
    background: "#f5f8fb",
    fontFamily: "Helvetica Neue",
    headerBgColor: "#25D366",
    headerFontColor: "#fff",
    headerFontSize: "15px",
    botBubbleColor: "#25D366",
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "#4a4a4a",
  };

  const steps = [
    {
      id: "1",
      message: `Hello! Welcome to ${data.Header.title}. How can I assist you today?`,
      trigger: "user-options",
    },
    {
      id: "user-options",
      options: [
        {
          value: "about",
          label: "Tell me about your company",
          trigger: "about",
        },
        {
          value: "services",
          label: "What services do you offer?",
          trigger: "services",
        },
        {
          value: "contact",
          label: "How can I contact you?",
          trigger: "contact",
        },
        {
          value: "gallery",
          label: "Show me the gallery",
          trigger: "gallery-options",
        },
      ],
    },
    {
      id: "about",
      message: data.About.paragraph,
      trigger: "user-options",
    },
    {
      id: "services",
      message: data.Services.map(
        (service) => `${service.name}: ${service.text}`
      ).join("\n"),
      trigger: "user-options",
    },
    {
      id: "contact",
      message: `You can reach us at:\nPhone: ${data.Contact.phone}\nEmail: ${data.Contact.email}`,
      trigger: "user-options",
    },
    {
      id: "gallery-options",
      message: "Here are our chilli varieties. Please select one to know more:",
      trigger: "gallery-list",
    },
    // Add gallery steps here if needed
    {
      id: "gallery-list",
      options: [
        {
          value: "sannam",
          label: "Dry Red Chillies - SANNAM",
          trigger: "sannam",
        },
        {
          value: "teja",
          label: "Dry Red Chillies - TEJA",
          trigger: "teja",
        },
        // Add more gallery options as needed
      ],
    },
    {
      id: "sannam",
      message:
        "Dry Red Chillies - SANNAM: Medium heat, vibrant color, popular in Asian cuisine.",
      trigger: "user-options",
    },
    {
      id: "teja",
      message:
        "Dry Red Chillies - TEJA: Known for its high heat and bright red color.",
      trigger: "user-options",
    },
    // Add more chilli descriptions as needed
  ];

  return (
    <div className="chatbot-container">
      {!isChatbotOpen && (
        <button
          style={{ border: "none", background: "none", borderRadius: "40%" }}
        >
          <FaCommentDots
            className="chatbot-icon"
            onClick={toggleChatbot}
            size={50}
            color="darkGreen"
          />{" "}
          {/* Message icon */}
        </button>
      )}
      {isChatbotOpen && (
        <div className="chatbot-content">
          <button className="close-chatbot" onClick={toggleChatbot}>
            ✖ {/* Close button */}
          </button>
          <ThemeProvider theme={theme}>
            <ChatBot steps={steps} />
          </ThemeProvider>
        </div>
      )}
    </div>
  );
};

export default ChatbotComponent;
